import { JarvisAuthProvider } from '@jarvis/web-http'
import { AxiosResponse } from 'axios'
import { Stack, WebClient } from '../../clients/web-client'
import {
  SessionPayload,
  CreateSessionResponse
} from '../../interface/controllerInterface'
import { buildMockResponse } from '../mock-utils'
import { Logger } from '../../utils/helperMethods'

export class OnboardingDirectorClientMock extends WebClient {
  /**
   *
   */
  constructor(
    baseURL: Stack | string = 'baseUrl',
    authProvider: JarvisAuthProvider = {
      getAccessToken: async () => 'token'
    }
  ) {
    super(baseURL, authProvider)
  }

  /**
   * Create mock session
   *
   * @returns Axios response object
   */
  async createSession(
    sessionPayload?: SessionPayload
  ): Promise<AxiosResponse<CreateSessionResponse>> {
    Logger.log('createSessionPayload', sessionPayload)
    const onboardingDirectorMockResponse = {
      sessionContext: {
        sessionId: 'a5b67u7r4-1d5d-4604-91ae-ff886879d36a',
        xCorrelationId:
          '[a5b67u7r4-1d5d-4604-91ae-ff886879d36a]-[onbp-jwv-landing-page]',
        onboardingContext: {
          experience: 'smb',
          entry: 'portalOobe',
          bizModelHint: 'E2E',
          entryUrl:
            'https://admin.hpsmart.com/activate?earlyOobe=easystartwin&printerUuid=abc'
        },
        app: {
          clientId: 'fdaa06d9-1d5d-4604-91ae-ff886879d36d',
          appVersion: 'HP Smart Windows 129.0.3914.0',
          osType: 'windows',
          osVersion: '10.0.17763.1',
          countryRegionIso: 'US',
          locale: 'en_GB',
          container: 'browser'
        },
        device: {
          uuid: 'string',
          productNumber: 'string',
          serialNumber: 'string',
          modelName: 'string',
          bizModel: 'string',
          cloudId: 'string',
          deviceLocation: 'string',
          deviceName: 'string',
          images: ['string'],
          highestResImgUrl: 'string',
          deviceCapabilities: {}
        },
        user: {
          initialAuthenticationState: 'notAuthenticated',
          currentAuthenticationState: 'notAuthenticated',
          consents: [
            {
              purposeId: 'string',
              state: 'string'
            }
          ]
        },
        tenant: {
          resourceId: 'string',
          accountName: 'string',
          type: 'string'
        },
        stepperState: [
          {
            stepId: 'onbp-step-assign-ownership',
            status: 'complete',
            order: 0
          }
        ]
      },
      nextService: {
        serviceId: 'onbp-jwv-landing-page',
        resultUrl: 'https://.../path/to/update/session',
        exitUrl: 'https://.../path/to/redirect/after/onboarding/finishes'
      }
    }

    return buildMockResponse(onboardingDirectorMockResponse)
  }
}
